import type { ApiCursorBody, ApiResponse } from '@/types/api-response.types'
import type { Article, ArticleDetail } from '@/types/article.types'
import api from '../axios'

export const articleService = {
  async getArticles(size: number, cursor?: number | null, ascending = false): Promise<ApiCursorBody<Article>> {
    const response: ApiResponse<ApiCursorBody<Article>> = await api.get('/v1/article', {
      params: {
        cursor,
        size,
        ascending,
      },
    })
    return response.body
  },

  async getArticleDetail(idx: number): Promise<ArticleDetail> {
    const response: ApiResponse<ArticleDetail> = await api.get(`/v1/article/${idx}`)
    return response.body
  },
}
